__turbopack_context__.v({
  "contactForm": "styles-module-scss-module__pB0BKa__contactForm",
  "docsMessage": "styles-module-scss-module__pB0BKa__docsMessage",
  "errorMessage": "styles-module-scss-module__pB0BKa__errorMessage",
  "formField": "styles-module-scss-module__pB0BKa__formField",
  "inputError": "styles-module-scss-module__pB0BKa__inputError",
  "submitButton": "styles-module-scss-module__pB0BKa__submitButton",
  "vertical": "styles-module-scss-module__pB0BKa__vertical",
});
